import { z } from 'zod'

//TODO: Ver se isso vai ficar asim mesmo, pois o DateTime não satisfaz
export const DateTime = z.string()
export type DateTime = z.infer<typeof DateTime>
